import React, { lazy, Suspense } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { routerUtil } from '@utils/config'
import { Loading } from '@com-components/'

const Blog = lazy(() => import('@pages/monitor/blog'))
const Alert = lazy(() => import('@pages/monitor/alert'))
const Night = lazy(() => import('@pages/monitor/night'))

export const routerConfig = [
  {
    name: '审计日志列表',
    path: '/monitor/blog',
    component: Blog
  },
  {
    name: '客户监控告警',
    path: '/monitor/alert',
    component: Alert
  },
  {
    name: '夜间监控数据',
    path: '/monitor/night',
    component: Night
  }
]
const routerMap = routerUtil.sortToRoute(routerConfig)

const PolicyRoutes = () => (
  <Suspense fallback={<Loading />}>
    <Switch>
      {routerMap.map(route => (
        <Route key={route.path} path={route.path} component={route.component} />
      ))}
      <Redirect to="/monitor/alert" />
    </Switch>
  </Suspense>
)

export default PolicyRoutes
